import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { CLAIMS_POSTING_INIT_LOADING, CLAIMS_POSTING_INIT_SUCCESS, CLAIMS_POSTING_INIT_FAIL } from '@/store/types'

export const post = {
  async claimPostingInit({ commit, state }) {
    if (state.posting.init !== 1) {
      const apiUrl = state.menu.posting
      if (apiUrl) {
        commit(CLAIMS_POSTING_INIT_LOADING)
        try {
          const result = await http.get(apiUrl)
          const menu = extractMenu(result.data._links)
          const commitResult = {
            menu: menu
          }
          commit(CLAIMS_POSTING_INIT_SUCCESS, commitResult)
        } catch (error) {
          commit(CLAIMS_POSTING_INIT_FAIL, extractMessages(error))
        }
      } else {
        commit(CLAIMS_POSTING_INIT_FAIL, ['Invalid API URL'])
      }
    }
  }
}
